module.exports = __webpack_public_path__ + "img/IMG_6258_FoamcoreMatted.259f9a39.jpg";